import Instagram from '../../assets/images/instagram-alt.svg';
import Phone from '../../assets/images/phone.svg';
import Mail from '../../assets/images/Mail.svg';
import logo from '../../assets/images/logo.png';


function Footer() {
  return (
    <div className="fallback-old-style">
          <div className="container-fluid bg-black">
    <div className="container">
    <div className="row footer-row pt-50 pb-30">
       <div className="col-lg-40 col-md-100 p-10 ">
         <div className="social pt-40 pb-40">
         
          <img src={logo} className="social-logo" alt="" />

          <ul >
            <li> <a href=""><img src={Instagram} /></a>  </li>
          </ul>

          <h3>We would like to hear from you. Let’s stay connected.</h3>

          <p> <img src={Phone} alt="" />  (888) 1234-5678</p>
          <p> <img src={Mail} alt="" />  info@example.com</p>

         
         </div>
     
  
       </div>
  
       <div className="col-lg-20 col-md-50  p-10 ">
        <div className="footermenu pt-40 pb-40">
         <ul >
          <li> <a href="">About Us</a>  </li>
          <li> <a href="/Plans">Membership Plans</a>  </li>
          <li> <a href="/Partners">Partner with us</a>  </li>
          <li> <a href="/ride-24">Ride&amp;Meet</a>  </li>
        </ul>
        </div>
      </div>

      <div className="col-lg-20 col-md-50  p-10 ">
        <div className="footermenu pt-40 pb-40">
          <ul >
           <li> <a href="">FAQs</a>  </li>
           <li> <a href="">Blog</a>  </li>
           <li> <a href="">Gallery</a>  </li>
         </ul>
        </div>
      </div>

      <div className="col-lg-20 col-md-50  p-10 ">
        <div className="footermenu pt-40 pb-40">
          <ul >
           <li> <a href="">Terms &amp; Conditions</a>  </li>
           <li> <a href="">Privacy Policy</a>  </li>
           <li> <a href="">Refund Policy</a>  </li>
           <li> <a href="">Support &amp; Contact</a>  </li>
         </ul>
        </div>
      </div>
      
       
    </div>
    </div>
  </div>

  <div className="container-fluid bg-black">
    <div className="container">
    <div className="social p-20">
      <h4>© All Right Reserved</h4>
    </div>

    </div>
  </div>
      
    </div>
  );
}

export default Footer;
